module.exports = __webpack_public_path__ + "static/media/account_icon.c1190383.svg";